module.exports = __webpack_public_path__ + "img/neiye.bbaee663.jpg";